import { getCalendarAgendaViewStore } from '../store/calendarAgendaViewStore';

/**
 * Check if the agenda view is shown
 */
export default function isAgendaViewShown(): boolean {
    return getCalendarAgendaViewStore().isAgendaViewShown;
}
